// extracted by mini-css-extract-plugin
export var card = "_ko-5";
export var cardSelected = "_ko-4";
export var image = "_ko-3";
export var modal = "_ko-0";
export var modalContent = "_ko-1";
export var table = "_ko-2";